import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/api';

import Modal from "./Modal"

import ParadigmaTable from "../../../components/ParadigmaTable/ParadigmaTable"



class Caja extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Código",
                    id: "codigo",
                    accessor: d => d.codigo,
                    show: true,
                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
                {
                    Header: "sucursal",
                    id: "sucursal",
                    accessor: d => d.sucursal ? d.sucursal.nombre : '',
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create: true,
                        component: (props) => <Modal {...props} action="CREATE" />,
                        permission: 'caja_caja_new',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="EDIT" />,
                        permission: 'caja_caja_edit',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DETAIL" />,
                        permission: 'caja_caja_detail',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DELETE" />,
                        permission: 'caja_caja_delete',
                    }
                ]}
                apiUrl={api.caja.caja}
                columns={this.state.columns}
                exportUrl={api.caja.caja}
                title={"Caja"}
            />
        );
    }
}

export default Caja;



// WEBPACK FOOTER //
// ./src/views/Caja/Caja/Caja.js